import type { FC } from 'react';
import classNames from 'classnames';

import { sort } from 'app/utils/array';

import style from './style.module.scss';

interface Props extends ClassNameProp {
  weak?: boolean;
  value: number;
  hideValue?: boolean;
  hidePercentageSign?: boolean;
  customColors?: { value: number; color: string }[];
  valueClassName?: string;
}

const CircularGauge: FC<Props> = ({
  weak,
  value,
  hideValue = false,
  className,
  hidePercentageSign = false,
  customColors,
  valueClassName
}) => {
  const strokeDashOffsetValue = 100 - value;

  const gaugeBar = classNames(style.gaugeBar, {
    [style.weak]: weak
  });

  const customColor = customColors
    ? sort(customColors, color => color.value)
        .reverse()
        .find(color => value > color.value)?.color
    : undefined;

  return (
    <span className={classNames(style.circularGauge, className)}>
      {/* We use circle with 15.9155 radius so that circumference = 100 */}
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" className={style.svg}>
        <circle cx="18" cy="18" r="15.9155" className={style.gaugeBackground} />
        <circle
          cx="18"
          cy="18"
          r="15.9155"
          className={gaugeBar}
          strokeDashoffset={strokeDashOffsetValue}
          style={customColor ? { stroke: customColor } : undefined}
        />
      </svg>
      {!hideValue && (
        <span className={classNames(style.value, valueClassName)}>
          {value}
          {hidePercentageSign ? '' : '%'}
        </span>
      )}
    </span>
  );
};

CircularGauge.displayName = 'CircularGauge';

export default CircularGauge;
